import { useContext } from 'react';

import BrowserContext from './BrowserContext';

const useBrowser = (throwOnMissingContext = true) => {
  const context = useContext(BrowserContext);
  if (context === null) {
    if (throwOnMissingContext) {
      throw new Error('useBrowser must be used within a BrowserProvider');
    }
    return {};
  }
  return context;
};

export default useBrowser;
